import { useEffect, useState } from "react";
import DataTable, { Column } from "../../../components/DataTable";
import { dropDownRed } from "../../../asset";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { fetchInvoices } from "../../../features/feesAndPayment/FeesAndPaymentSlice";
import { Invoice } from "../../../types/feesAndPaymentType";
import { formatDateTime } from "../../../util/functions/UniversalFunctions";

export default function FeesList({ admissionNumber }: { admissionNumber?: number }) {
  const [searchFilters, setSearchFilters] = useState({
    studentAdmissionNumber: "",
  });
  const dispatch = useDispatch<AppDispatch>();
  const { invoices, page, size } = useSelector(
    (state: RootState) => state.fees,
  );

  const branchCode = useSelector(
    (state: RootState) => state.access.schoolBranch,
  );

  useEffect(() => {
    dispatch(
      fetchInvoices({
        branchCode: branchCode.schoolBranchCode,
        schoolCode: branchCode.schoolCode,
        studentAdmissionNumber: admissionNumber,

        page,
        size,
      }),
    );
  }, [page, size, branchCode, dispatch]);

  const columns: Column<Invoice>[] = [
    {
      label: "SL NO.",
      accessor: "slNo",
      render: (_, index) => <p>{index + 1}</p>,
    },
    {
      label: "Invoice Number",
      accessor: "invoiceId",
      // searchable: true,
    },
    {
      label: "Invoice Date",
      accessor: "date",
      // searchable: true,
      // searchType: "date",
      render: (item) => (
        <p className="text-[13px]">{formatDateTime(item.dueDate) || "N/A"}</p>
      ),
    },
    {
      label: "Status",
      accessor: "status",
      // searchable: true,
      searchType: "select",
      searchOptions: ["sent", "paid", "pending"],
      render: (item) => (
        <span className="text-warning-600 capitalize font-semibold">
          {item.paymentStatus}
        </span>
      ),
    },
    {
      label: "Amount Payable(₹)",
      accessor: "amountPayable",
      render: (item) => (
        <div className="text-neutral-400 text-sm font-bold">
          ₹ {item.amount}
        </div>
      ),
    },
    {
      label: "Amount Received(₹)",
      accessor: "amountReceive",
      render: (item) => (
        <div className="text-success-600 text-sm font-bold">
          ₹ {item.amountReceived ?? "0"}
        </div>
      ),
    },
    {
      label: "Balance",
      accessor: "balance",
      render: (item) => {
        const amount = Number(item.amount) || 0;
        const received = Number(item.amountReceived) || 0;
        return (
          <div className="text-error-600 font-bold">₹ {amount - received}</div>
        );
      },
    },
    {
      label: "Action",
      accessor: "action",
      render: (item) => (
        <button className="px-2 py-1 flex gap-2 items-center text-nowrap text-xs text-error-700 bg-error-50 rounded-[4px] font-medium">
          Delete
          <img src={dropDownRed} alt="delete" />
        </button>
      ),
    },
  ];

  const handleSearchChange = (accessor: string, value: string) => {
    setSearchFilters((prev) => ({ ...prev, [accessor]: value }));
  };

  const handleSearchSubmit = (filters: Record<string, string>) => {
    // setSearchFilters(filters);
  };

  return (
    <div className="px-4 md:px-9 py-7">
      <DataTable
        columns={columns}
        data={invoices}
        searchFilters={searchFilters}
        onSearchChange={handleSearchChange}
        onSearchSubmit={handleSearchSubmit}
      />
    </div>
  );
}
